import { EmployeeScores } from '../services/EmployeeService'

export const calculateEmployeeScore = (employee: EmployeeScores, totalTopics: number): EmployeeScores => {
  employee.score = Math.round(
    ((employee.avgProductivity || 0) +
      (employee.avgGrowthMindset || 0) +
      (employee.avgCommitment || 0) +
      (employee.avgCommunication || 0) +
      (employee.avgProfessionalSkills || 0)) /
      totalTopics
  )
  return employee
}

export const calculateAvgReviewForTeam = (teamEmployees: EmployeeScores[], totalTopics: number): EmployeeScores => {
  const result: EmployeeScores = {
    id: -1,
    name: 'Team Average',
    avgProductivity: 0,
    avgGrowthMindset: 0,
    avgCommitment: 0,
    avgCommunication: 0,
    avgProfessionalSkills: 0,
    score: 0,
    isGlobalScore: true,
    skipped: false,
  }

  if (teamEmployees && teamEmployees.length > 0) {
    const amountWithReviews = teamEmployees.filter(e => e.lastReviewType != null).length || 1
    teamEmployees.forEach(review => {
      result.avgProductivity = (result.avgProductivity || 0) + (review.avgProductivity || 0)
      result.avgGrowthMindset = (result.avgGrowthMindset || 0) + (review.avgGrowthMindset || 0)
      result.avgCommitment = (result.avgCommitment || 0) + (review.avgCommitment || 0)
      result.avgCommunication = (result.avgCommunication || 0) + (review.avgCommunication || 0)
      result.avgProfessionalSkills = (result.avgProfessionalSkills || 0) + (review.avgProfessionalSkills || 0)
    })
    result.avgProductivity = Math.round((result.avgProductivity || 0) / amountWithReviews)
    result.avgGrowthMindset = Math.round((result.avgGrowthMindset || 0) / amountWithReviews)
    result.avgCommitment = Math.round((result.avgCommitment || 0) / amountWithReviews)
    result.avgCommunication = Math.round((result.avgCommunication || 0) / amountWithReviews)
    result.avgProfessionalSkills = Math.round((result.avgProfessionalSkills || 0) / amountWithReviews)
    result.score = Math.round(
      (result.avgProductivity +
        result.avgGrowthMindset +
        result.avgCommitment +
        result.avgCommunication +
        result.avgProfessionalSkills) /
        totalTopics
    )
  }
  return result
}
